import { required } from 'vuelidate/lib/validators';

export default {
  validations: {
    loginApi: {
      email: {
        required,
      },
      password: {
        required,
      },
    },
  },
};
